import {
  WorkOrderPecaAiOrderShippingStatus,
  WorkOrderPecaAiOrderStatus,
} from './workorder-pecaAi.enums';

export const WorkOrderPecaAiOrderShippingStatusLabel: Record<
  WorkOrderPecaAiOrderShippingStatus,
  string
> = {
  PENDING: 'Pendente',
};

export const WorkOrderPecaAiOrderShippingStatusColor: Record<
  WorkOrderPecaAiOrderShippingStatus,
  string
> = {
  PENDING: 'blue',
};

export const WorkOrderPecaAiOrderStatusLabel: Record<
  WorkOrderPecaAiOrderStatus,
  string
> = {
  CANCELED: 'Cancelado',
  IN_SEPARATION: 'Em separação',
};

export const WorkOrderPecaAiOrderStatusColor: Record<
  WorkOrderPecaAiOrderStatus,
  string
> = {
  CANCELED: 'red',
  IN_SEPARATION: 'blue',
};
